function TextArea(props) {
  return (
    <div className={'rtds-input-field rtds-gap-1' + (props.inputErrors?.includes(props.id) ? ' has-error' : '')} hidden={props.hidden}>
      <label htmlFor={props.id} className='rtds-input-field__label'>
        {props.label}{props.required ? ' ' : ''}
        <abbr
          hidden={!props.required}
          className='rtds-font-bold rtds-no-underline'
          title='obbligatorio'
        >
          *
        </abbr>
      </label>

      <div className={(props.classDivInput ?? 'rtds-input') + (props.inputErrors?.includes(props.id) ? ' has-error' : '')}>
        <textarea
          required={!!props.required}
          id={props.id}
          name={props.id}
          className={props.classTextArea + (props.disabled ? ' rtds-background-02' : '')}
          type={props.type}
          aria-describedby={props.id + 'Error'}
          onChange={(event) => props.onChange(event)}
          aria-invalid={props.inputErrors?.includes(props.id)}
          value={props.value}
          disabled={props.disabled}
          hidden={props.hidden}
          title={props.title}
          maxLength={props.maxLength}
          style={props.style ?? null}
        />
        {
          props.inputErrors?.includes(props.id) && 
          <svg
            className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-absolute rtds-right-4 rtds-content-placeholder rtds-content-error'
            aria-hidden='true'
            focusable='false'
            role='img'
          >
            <use
              xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--exclamation-circle`}
            />
          </svg>
        }
      </div>

      <span className='rtds-input-field__hint' hidden={!props.inputErrors?.includes(props.id)}>
        <span
          className='rtds-input-field__error'
          id={props.id + 'Error'}
          aria-live='assertive'
        >
          {props.errorMessage ?? 'Campo obbligatorio'}
        </span>
      </span>
      {
        !props.hideMaxLength && props.maxLength &&
        <span className="rtds-input-field__hint">
          <span className="rtds-input-field__description" id="idselectDescription">
            Massimo {props.maxLength} caratteri
          </span>
        </span>
      }
    </div>
  );
}

export default TextArea;
